"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormSettings = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactFormSettings = class ContactFormSettings extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
    }
    get canDisplay() {
        return this.content.tabs.contactForm.canDisplay;
    }
    set canDisplay(value) {
        this.content.tabs.contactForm.canDisplay = value;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true, default: {} }),
    __metadata("design:type", Object)
], ContactFormSettings.prototype, "content", void 0);
ContactFormSettings = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactFormSettings',
        components: {
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck
        },
        template: `
    <div @click.stop>
      <div class="p-3 my-2 w-100">
        <DashmixCheck class="pb-2" :label="$t('forms.contact.tabs.'+content.tabs.contactForm.id+'.canDisplay')" name="contactform"
                      :model.sync="canDisplay" />
      </div>
    </div>
  `
    })
], ContactFormSettings);
exports.ContactFormSettings = ContactFormSettings;
//# sourceMappingURL=ContactFormSettings.js.map